module.exports = __webpack_public_path__ + "img/09.fbc4b482.jpg";